export const CARRIERS = {
  en: [
    {
      text: "Royal Mail",
      value: "Royal Mail",
      logo: "royalmail.svg",
      method: "Tracked 24",
    },
    {
      text: "Hermes",
      value: "Hermes",
      logo: "hermes.png",
      method: "",
    },
    {
      text: "UPS",
      value: "UPS",
      logo: "ups.svg",
      method: "3-Day Select",
    },
    {
      text: "DHL",
      value: "DHL",
      logo: "dhl.svg",
      method: "Express",
    },
    {
      text: "Parcelforce",
      value: "Parcelforce",
      logo: "parcelforce.png",
      method: "express24",
    },
  ],
  fr: [
    {
      text: "Colissimo",
      value: "Colissimo",
      logo: "colissimo.svg",
      method: "Express",
    },
    {
      text: "Chronopost",
      value: "Chronopost",
      logo: "chronopost.svg",
      method: "Globalpack",
    },
    {
      text: "Mondial Relay",
      value: "Mondial Relay",
      logo: "mondial_relay.svg",
      method: "Same day",
    },
    {
      text: "Lettre suivie",
      value: "Lettre suivie",
      logo: "lettresuivie.svg",
      method: "3-Day Select",
    },
    {
      text: "UPS",
      value: "UPS",
      logo: "UPS.svg",
      method: "Global",
    },
    {
      text: "DHL express",
      value: "DHL express",
      logo: "dhl.svg",
      method: "PACK 24",
    },
  ],
  es: [
    {
      text: "Correos",
      value: "Correos",
      logo: "correos.svg",
      method: "",
    },
    {
      text: "Correos Express",
      value: "Correos Express",
      logo: "correos_express.png",
      method: "Express",
    },
    {
      text: "SEUR",
      value: "SEUR",
      logo: "seur.svg",
      method: "Same day",
    },
    {
      text: "DHL Express",
      value: "DHL Express",
      logo: "dhl.svg",
      method: "",
    },
    {
      text: "UPS",
      value: "UPS",
      logo: "ups.svg",
      method: "Standard",
    },
  ],
  it: [
    {
      text: "Poste Italiane",
      value: "Poste Italiane",
      logo: "poste-italiane.svg",
      method: "Crono Express",
    },
    {
      text: "DHL Express",
      value: "DHL Express",
      logo: "dhl.svg",
      method: "",
    },
    {
      text: "UPS",
      value: "UPS",
      logo: "ups.svg",
      method: "Standard",
    },
  ],
  nl: [
    {
      text: "PostNL",
      value: "PostNL",
      logo: "postnl.svg",
      method: "GlobalPack",
    },
    {
      text: "DPD",
      value: "DPD",
      logo: "dpd.svg",
      method: "Express",
    },
    {
      text: "Red je pakketje",
      value: "Red je pakketje",
      logo: "rjp.svg",
      method: "Same day",
    },
    {
      text: "DHL Express",
      value: "DHL Express",
      logo: "dhl.svg",
      method: "",
    },
    {
      text: "UPS",
      value: "UPS",
      logo: "ups.svg",
      method: "",
    },
  ],
  de: [
    {
      text: "Deutsche Post",
      value: "Deutsche Post",
      logo: "dp.svg",
      method: "",
    },
    {
      text: "DPD",
      value: "DPD",
      logo: "dpd.svg",
      method: "Express",
    },
    {
      text: "DHL",
      value: "DHL",
      logo: "dhl.svg",
      method: "Business",
    },
    {
      text: "DHL Express",
      value: "DHL Express",
      logo: "dhl.svg",
      method: "",
    },
    {
      text: "UPS",
      value: "UPS",
      logo: "ups.svg",
      method: "Global",
    },
  ],
};
